import { Grid, IconButton } from "@material-ui/core";
import { CheckCircle, FileCopy } from "@material-ui/icons";
import RxTypography from "../../../components/RxTypography";
import { AcademicInfoDTO } from "../../../constants/CommonObject";
import styles from "../AcademicLicence.module.css";

interface AuthUserAcademicLicencePageProps {
	academicInfo: AcademicInfoDTO;
}

const AuthUserAcademicLicencePage = (
	props: AuthUserAcademicLicencePageProps
) => {
	return (
		<Grid
			container
			spacing={1}
			direction="row"
			justifyContent="center"
			alignItems="center"
			alignContent="center"
		>
			<Grid item xs={12} sm={12}>
				<Grid container spacing={8}>
					<Grid item xs={12} sm={12}>
						<Grid
							container
							alignItems="center"
							justifyContent="center"
							spacing={4}
						>
							<CheckCircle className={styles.academicLicenceIcon} />
							<Grid item>
								<RxTypography
									variant="caption"
									align="center"
									label={<strong>Akademik Lisans Bilgileri</strong>}
								/>
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12}>
								<RxTypography
									variant="subtitle1"
									align="center"
									label={
										<>{`${props.academicInfo.endDate} tarihine kadar geçerli akademik lisansınız bulunmaktadır.`}</>
									}
								/>
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12}>
								<RxTypography
									variant="caption"
									align="center"
									label={<strong>Lisans Numaranız:</strong>}
								/>
							</Grid>
						</Grid>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12}>
								<Grid container>
									<Grid item xs={4} />
									<Grid item xs={4}>
										<RxTypography
											variant="h6"
											align="center"
											label={
												<code>{`${props.academicInfo.licenceKey}`}</code>
											}
										/>
									</Grid>
									<Grid item xs={3}>
										<IconButton
											aria-label="Kopyala"
											onClick={() => {
												navigator.clipboard.writeText(
													props.academicInfo.licenceKey
												);
											}}
											size="small"
											color="primary"
										>
											<FileCopy />
										</IconButton>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default AuthUserAcademicLicencePage;
